class MobileSlider {
  constructor(container, autoPlayInterval = 10000) {
    this.track = container.querySelector(".slider-track");
    this.slides = container.querySelectorAll(".m-slide");
    this.dotsContainer = container.querySelector(".slider-dots");
    this.prevBtn = container.querySelector("#prevBtn");
    this.nextBtn = container.querySelector("#nextBtn");

    this.currentIndex = 0;
    this.slidesCount = this.slides.length;

    this.startX = 0;
    this.currentX = 0;
    this.isDragging = false;
    this.hasMoved = false;
    this.threshold = 50;

    this.autoPlayInterval = autoPlayInterval;
    this.autoPlayTimer = null;

    this.init();
  }

  init() {
    this.createDots();
    this.bindEvents();
    this.updateSlider();
    this.startAutoPlay();
  }

  createDots() {
    for (let i = 0; i < this.slidesCount; i++) {
      const dot = document.createElement("div");
      dot.classList.add("dot");
      if (i === 0) dot.classList.add("active");
      dot.addEventListener("click", () => {
        this.goToSlide(i);
        this.resetAutoPlay();
      });
      this.dotsContainer.appendChild(dot);
    }
    this.dots = this.dotsContainer.querySelectorAll(".dot");
  }

  bindEvents() {
    // Touch события (свайп)
    this.track.addEventListener("touchstart", (e) => this.handleStart(e), {
      passive: true,
    });
    this.track.addEventListener("touchmove", (e) => this.handleMove(e), {
      passive: false,
    });
    this.track.addEventListener("touchend", (e) => this.handleEnd(e));

    // Mouse события (свайп мышью)
    this.track.addEventListener("mousedown", (e) => this.handleStart(e));
    this.track.addEventListener("mousemove", (e) => this.handleMove(e));
    this.track.addEventListener("mouseup", (e) => this.handleEnd(e));
    this.track.addEventListener("mouseleave", (e) => {
      if (this.isDragging) this.handleEnd(e);
    });
  }

  handleStart(e) {
    this.isDragging = true;
    this.hasMoved = false;
    this.startX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
    this.currentX = this.startX;
    this.track.classList.add("dragging");
  }

  handleMove(e) {
    if (!this.isDragging) return;

    this.currentX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;

    const diff = this.currentX - this.startX;

    if (Math.abs(diff) > 5) {
      this.hasMoved = true;
      e.preventDefault();
    }

    const offset =
      -this.currentIndex * 100 + (diff / this.track.offsetWidth) * 100;
    this.track.style.transform = `translateX(${offset}%)`;
  }

  handleEnd(e) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.track.classList.remove("dragging");

    const diff = this.currentX - this.startX;

    // Свайп
    if (this.hasMoved && Math.abs(diff) > this.threshold) {
      if (diff > 0) {
        this.prev();
      } else {
        this.next();
      }
      this.resetAutoPlay();
    } else {
      this.updateSlider();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.slidesCount - 1;
    }
    this.updateSlider();
  }

  next() {
    if (this.currentIndex < this.slidesCount - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0;
    }
    this.updateSlider();
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateSlider();
  }

  updateSlider() {
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === this.currentIndex);
    });
  }

  startAutoPlay() {
    this.autoPlayTimer = setInterval(() => {
      this.next();
    }, this.autoPlayInterval);
  }

  stopAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer);
      this.autoPlayTimer = null;
    }
  }

  resetAutoPlay() {
    this.stopAutoPlay();
    this.startAutoPlay();
  }
}

// Инициализация: 10000 мс = 10 секунд
const sliderContainer = document.querySelector(".slider-container");
const slider = new MobileSlider(sliderContainer, 10000);
